import gql from "graphql-tag";

// Get list of Leave type
const GET_LEAVE_STATUS = gql`
	query Get_LeaveStatuses($site: ID!) {
		GetLeaveStatusList(site: $site) {
			docs {
				created_at
				id
				name
			}
		}
	}
`;

// New LeaveStatus
const NEW_LEAVE_STATUS = gql`
	mutation NewLeaveStatus($name: String!, $site: ID!) {
		NewLeaveStatus(name: $name, site: $site) {
			message
			doc {
				name
				id
				created_at
			}
		}
	}
`;
// Update LeaveStatus
const UPDATE_LEAVE_STATUS = gql`
	mutation UpdateLeaveStatus($name: String!, $id: ID!) {
		UpdateLeaveStatus(name: $name, id: $id) {
			message
			doc {
				name
				id
				created_at
			}
		}
	}
`;

export { GET_LEAVE_STATUS, NEW_LEAVE_STATUS, UPDATE_LEAVE_STATUS };
